export default __webpack_public_path__ + "static/media/img5.0564de5d.webp";